import { Inject } from '@angular/core';
import '@angular/compiler';
import { PortalKorenetOrganizationDetailComponent } from './portal.korenet.organization.detail/portal.korenet.organization.detail.component';
import { PageAdminComponent } from './page.admin/page.admin.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PortalChatbotComponentChatbotComponent } from './portal.chatbot.component.chatbot/portal.chatbot.component.chatbot.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PageSearchComponent } from './page.search/page.search.component';
import { LayoutKorenetComponent } from './layout.korenet/layout.korenet.component';
import { PortalAdminResearcherComponent } from './portal.admin.researcher/portal.admin.researcher.component';
import { PortalAdminVectorComponent } from './portal.admin.vector/portal.admin.vector.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PortalAdminUsersComponent } from './portal.admin.users/portal.admin.users.component';
import { PageResearcherItemComponent } from './page.researcher.item/page.researcher.item.component';
import { PortalAdminOrgComponent } from './portal.admin.org/portal.admin.org.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PageHomeComponent } from './page.home/page.home.component';
import { PageResearcherDiscoveryComponent } from './page.researcher.discovery/page.researcher.discovery.component';
import { ComponentNavComponent } from './component.nav/component.nav.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PortalAdminCacheComponent } from './portal.admin.cache/portal.admin.cache.component';
import { PageSignupComponent } from './page.signup/page.signup.component';
import { PortalAdminUploadlogComponent } from './portal.admin.uploadlog/portal.admin.uploadlog.component';
import { PageOrganizationItemComponent } from './page.organization.item/page.organization.item.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PortalAdminUploadComponent } from './portal.admin.upload/portal.admin.upload.component';
import { PortalAdminDataComponent } from './portal.admin.data/portal.admin.data.component';
import { RouterModule } from '@angular/router';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NuMonacoEditorModule } from '@ng-util/monaco-editor';
import { SortablejsModule } from "src/libs/portal/season/ngx-sortablejs";
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(@Inject( DomSanitizer) private domSanitizer: DomSanitizer) { }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

// translate libs
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient, HttpClientModule } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

// initialize ng module
@NgModule({
    declarations: [
        SafePipe,
        AppComponent,
        PortalKorenetOrganizationDetailComponent,
        PageAdminComponent,
        PortalSeasonLoadingSeasonComponent,
        PortalChatbotComponentChatbotComponent,
        PortalSeasonModalComponent,
        PortalPostListComponent,
        PortalSeasonLoadingDefaultComponent,
        PageSearchComponent,
        LayoutKorenetComponent,
        PortalAdminResearcherComponent,
        PortalAdminVectorComponent,
        PortalSeasonPaginationComponent,
        PortalAdminUsersComponent,
        PageResearcherItemComponent,
        PortalAdminOrgComponent,
        PortalPostDetailComponent,
        PageHomeComponent,
        PageResearcherDiscoveryComponent,
        ComponentNavComponent,
        PortalSeasonFormDropdownComponent,
        PortalAdminCacheComponent,
        PageSignupComponent,
        PortalAdminUploadlogComponent,
        PageOrganizationItemComponent,
        PortalSeasonTreeComponent,
        PortalAdminUploadComponent,
        PortalAdminDataComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        SortablejsModule,
        KeyboardShortcutsModule.forRoot(),
        NuMonacoEditorModule.forRoot({ baseUrl: `lib` }),
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
                RouterModule
    ],
    providers: [
        {
            provide: COMPOSITION_BUFFER_MODE,
            useValue: false
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }